// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  padding: 30px 20px;
  text-align: center;
}

h3 {
  text-transform: none;
}

.m-b {
  margin-top: 15px;
}

ion-item {
  --border-width: 1px !important;
  --border-radius: 16px !important;
  --border-bottom: none;
  border: none;
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/subscribe-to-mailing-checkbox/confirm-mailing-subs-modal/confirm-mailing-subs-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,8BAAA;EACA,gCAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AACF","sourcesContent":[":host{\n  padding: 30px 20px;\n  text-align: center;\n}\n\nh3 {\n  text-transform: none;\n}\n\n.m-b{\n  margin-top: 15px;\n}\n\nion-item {\n  --border-width: 1px !important;\n  --border-radius: 16px !important;\n  --border-bottom: none;\n  border: none;\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
